import { ThemeProvider } from '@mui/material/styles'
import AppRoutes from 'app/container/app.routes'
import NotificationProvider2 from 'app/contexts/notification/notificationProvider2'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Application } from 'react-rainbow-components'
import { DEFAULT_THEME, DEFAULT_THEME_RAINBOW } from 'theme/default.theme'
import './app.scss'
// import NotificationFirebase from 'domains/notification-push/containers/notification-firebase/notification-firebase'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  return (
    <NotificationProvider2>
      <Application theme={DEFAULT_THEME_RAINBOW} style={{ height: '100%' }}>
        <div className="app">
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={DEFAULT_THEME}>
              <AppRoutes />
              {/* <NotificationFirebase /> */}
            </ThemeProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </div>
      </Application>
    </NotificationProvider2>
  )
}

export default App
